import React from "react";
import styles from "./style.scss";
import { loadCorporationChildPagePaths, validatePath } from "utils/helper/url";

import Usual from "./Usual";
import SharesHoldings from "./SharersHoldings";
import Overview from "./Overview";
import MaStrategy from "./MaStrategy";
import { isEmpty } from "utils/helper/common";
import Investment from "./Investment";
import Tdb from "./Tdb/index";
import TrendReport from "./TrendReport";
import TrendReportPrint from "./TrendReport/Print";
import ArticleStrategy from "./ArticleStrategy";
import Notice from "./Notice";
import { useMobilePage } from "hooks/useMobilePage";

const vp = validatePath("popup");

/**
 * ポップアップ
 */
const Popup = props => {
  const isMobilePage = useMobilePage();
  const searchParams = new URLSearchParams(props.location.search);
  const overviewPath = loadCorporationChildPagePaths("corporation", "basics")[1]
    .path;
  const overviewPathUnlisted = `${overviewPath}/unlisted`;

  // StrictModeの二重レンダリングチェックで壊れないよう、マッチしたルートを
  // 描画中のミュータブルな変数(match)ではなく純粋な配列探索で決定する
  const routes = [
    {
      path: [
        overviewPath,
        overviewPathUnlisted,
        loadCorporationChildPagePaths("corporation", "meeting")[0].path
      ],
      component: Overview
    },
    {
      path: loadCorporationChildPagePaths("corporation", "shares")[1].path,
      render: () => <SharesHoldings {...props.sharesHoldingsProps} />
    },
    {
      path: `${
        loadCorporationChildPagePaths("corporation", "shares")[0].path
      }/investments`,
      component: Investment
    },
    {
      path: vp("/corp/ma-strategy/ma"),
      component: MaStrategy
    },
    {
      path: [vp("/corp/summary/tdb-corp"), vp("/corp/summary/tdb-finance")],
      render: () => <Tdb {...{ ...props, ...props.tdbPopupProps }} />
    },
    {
      path: vp("/home/trend-report"),
      render: () => <TrendReport {...props.trendReportProps} />
    },
    {
      path: vp("/home/trend-report-print"),
      render: () => <TrendReportPrint {...props.trendReportProps} />
    },
    {
      path: vp("/binder"),
      articleKbn: "4",
      render: () => <TrendReport {...props.trendReportProps} />
    },
    {
      path: vp("/article/strategy"),
      component: ArticleStrategy
    },
    {
      path: vp("/home/notice"),
      render: () => <Notice {...props.noticeProps} />
    },
    {
      // デフォルトのポップアップ、マッチするパスがなければこれが表示される
      path: props.pathname,
      articleKbn: searchParams.get("articleKbn"),
      component: Usual
    }
  ];

  const matchedRoute = routes.find(({ path, articleKbn }) => {
    const paths = Array.isArray(path) ? path : [path];
    const isMatchArticleKbn = articleKbn
      ? articleKbn === searchParams.get("articleKbn")
      : true;
    return paths.includes(props.pathname) && isMatchArticleKbn;
  });

  const matchedContent = isEmpty(matchedRoute)
    ? null
    : !isEmpty(matchedRoute.render)
    ? matchedRoute.render()
    : React.createElement(matchedRoute.component, { ...props, isMobilePage });

  return <div className={styles.component}>{matchedContent}</div>;
};

export default Popup;
